import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { HelpCircle } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const { t, i18n } = useTranslation('faq');
  const [currentLang, setCurrentLang] = useState(i18n.language);
  
  // Force re-render when language changes
  useEffect(() => {
    setCurrentLang(i18n.language);
  }, [i18n.language]);
  
  // Array of FAQ keys - will be translated in render
  const faqItems = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'];

  return (
    <section className="section bg-gradient-to-br from-gray-50 to-white">
      <div className="container">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-14 h-14 bg-[#0B3F84] rounded-full mb-6">
              <HelpCircle className="text-white" size={28} />
            </div>
            <h2 className="text-4xl font-bold text-[#0A0A0A] mb-4">
              {t('title')}
            </h2>
            <p className="text-xl text-gray-600">
              {t('subtitle')}
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-4" key={currentLang}>
            {faqItems.map((item, index) => (
              <AccordionItem 
                key={`faq-${currentLang}-${item}`} 
                value={`faq-${index}`} 
                className="bg-white rounded-xl border border-gray-200 px-6"
              >
                <AccordionTrigger className="text-lg font-semibold text-[#0A0A0A] hover:text-[#0B3F84] text-left">
                  {t(item)}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 pt-4">
                  {t(`a${item.substring(1)}`)}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
